<template>
    <div style="padding: 8px;">
        <grid v-model="data" :descriptions="descriptions"/>
    </div>
</template>

<script>
    import qrCodeProjectDetailsService from '../service/qrCodeProjectDetailsService';
    import Grid from "../components/Grid";
    import {Button, Toast} from "vant";


    const _ = require('lodash');

    export default {
        data: function () {
            return {
                descriptions: [], // 字段信息
                data: {} // 对应数据
            }
        },
        created: async function () {
            let dataResp = await qrCodeProjectDetailsService.getProjectInfo(this.$route.params.corpId, this.$route.params.projectId);
            if (dataResp.data.Status === "1") {
                this.descriptions = dataResp.data.Data.description;
                this.data = dataResp.data.Data.data;
            }
        },
        components: {
            Grid,
            [Button.name]: Button
        }
    }
</script>